import BANK_ACCOUNTS from './bankAccounts.gql';
import SELECT_PREPAYMENT_BANK_ACCOUNT from './selectPrepaymentBankAccount.gql';

export {
  BANK_ACCOUNTS,
  SELECT_PREPAYMENT_BANK_ACCOUNT,
};
